/* Mobile gallery navigation for product profiles without an existing arrow UI. */
(() => {
  function start() {
    document.querySelectorAll('.shopify-section--main-product product-gallery').forEach(gallery => {
      const list = gallery.querySelector('.product-gallery__image-list');
      const carousel = gallery.querySelector('scroll-carousel');
      if (!list || !carousel?.id || list.querySelector('.sm-mobile-gallery-arrow,.sm-family-gallery-arrow,.sm-universal-gallery-arrow') || gallery.querySelector('.product-gallery__carousel-with-arrows')) return;
      const controls = {};
      ['prev','next'].forEach(direction => {
        const control = document.createElement('carousel-'+direction+'-button');
        control.className = 'sm-universal-gallery-arrow';
        control.dataset.direction = direction;
        control.setAttribute('aria-controls',carousel.id);
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label',direction==='prev'?'Previous image':'Next image');
        button.innerHTML = '<svg viewBox="0 0 14 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="'+(direction==='prev'?'M10 3 3 10l7 7':'m4 3 7 7-7 7')+'"/></svg>';
        control.append(button);list.append(control);controls[direction]=control;
      });
      const update = event => {
        const cells = carousel.cells || [...carousel.children].filter(cell=>!cell.hidden);
        const index = event?.detail?.index ?? carousel.selectedIndex ?? 0;
        controls.prev.hidden = index<=0 || cells.length<2;
        controls.next.hidden = index>=cells.length-1 || cells.length<2;
      };
      ['carousel:change','carousel:settle','carousel:filter'].forEach(type=>carousel.addEventListener(type,update));
      update();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();
